import { render } from "./ProyectoList.vue?vue&type=template&id=718739ba&scoped=true"
import script from "./ProyectoList.vue?vue&type=script&lang=js"
export * from "./ProyectoList.vue?vue&type=script&lang=js"

import "./ProyectoList.vue?vue&type=style&index=0&id=718739ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718739ba"]])

export default __exports__